import { UPDATE_HEADER_VISIBLE } from '../constants/actionTypes'

export default (state = true, action) => {
    switch (action.type) {
        case UPDATE_HEADER_VISIBLE:
            return action.payload
        default:
            return state
    }
}
